import { useEffect, useState } from 'react'
import type { CompanyItems } from '../../domain/company'
import { AxiosCompanyRepository } from '../../infrastructure/AxiosCompanyRepository'
import { ListCompaniesUseCase } from '../../usecases/ListCompaniesUseCase'

interface UseCompaniesOptions {
    search?: string
    page?: number
}

const useCompanies = (options: UseCompaniesOptions = {}) => {
    const [companies, setCompanies] = useState<CompanyItems[]>([])
    const [pagination, setPagination] = useState({
        totalItems: 10,
        page: 1,
        itemsPerPage: 10,
    })
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const { search = '', page = 1 } = options

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                setIsLoading(true)
                setError(null)

                const repository = new AxiosCompanyRepository()
                const useCase = new ListCompaniesUseCase(repository)

                const result = await useCase.execute({ name: search, page })

                setCompanies(
                    result.items.map((item: CompanyItems) => ({
                        ...item,
                    }))
                )
                setPagination({
                    page: result.page,
                    totalItems: result.totalItems,
                    itemsPerPage: result.size,
                })
            } catch (err) {
                setError(
                    err instanceof Error
                        ? err.message
                        : 'Error fetching companies'
                )
                setCompanies([])
            } finally {
                setIsLoading(false)
            }
        }

        fetchCompanies()
    }, [search, page]) // Add dependencies to trigger re-fetch on search/page change

    return {
        companies,
        pagination,
        isLoading,
        error,
    }
}

export default useCompanies
